<template>
  <div>
    <div style="display: flex">
      <div style="font-size: 30px;color: #6495ED;margin-right: 20px">聊天信息</div>
      <el-button @click="drawer = true" type="primary">设置参数</el-button>
    </div>

    <!--抽屉-->
    <el-drawer
        title="设置chatGPT的参数"
        :visible.sync="drawer"
        :direction="direction">
      <div style="margin: 20px">
        <!--chatGPT的model类型-->
        <div>
          <span>chatGPT的model类型</span>
          <div>
            <el-select v-model="model" placeholder="请选择">
              <el-option
                  v-for="item in modelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!--chatGPT的template参数-->
        <div style="margin-top: 50px">
          <span>控制随机性，接近0时，模型变得确定和重复</span>
          <el-slider style="width: 300px" :format-tooltip="formatTooltip" v-model="template"></el-slider>
        </div>
      </div>
    </el-drawer>

    <!-- 消息框的消息 -->
    <ul style="list-style: none;">
      <li v-for="(item,index) in message_array" :key="index">
        <div v-html="item"></div>
      </li>
    </ul>

    <!-- 消息输入框 -->
    <div style="margin: 36px">
      <el-input v-model="msg" style="width: 400px"></el-input>
      <el-button type="primary" @click="send" v-loading.fullscreen.lock="fullscreenLoading">发消息</el-button>
    </div>
  </div>
</template>

<script>
import {chatGPT} from "@/api/chatGPT";

export default {
  name: "ChatGPT",
  data() {
    return {
      //抽屉
      drawer: false,
      direction: 'rtl',

      msg: "",
      myMessage: "",
      // 对话框数组
      message_array: [],

      //加载中的状态
      fullscreenLoading: false,

      //chatGPT的配置参数
      modelOptions: [{
        value: 'text-davinci-003',
        label: 'text-davinci-003: 最强大的GPT-3模型。可以完成其他模型可以完成的任何任务，通常具有更高的质量、更长的输出和更好的指令遵从性。还支持在文本中插入补全'
      }, {
        value: 'text-curie-001',
        label: 'text-curie-001: 非常能干，但比达文西更快，成本更低'
      }, {
        value: 'text-babbage-001',
        label: 'text-babbage-001: 能够完成简单的任务，速度快，成本低'
      }, {
        value: 'text-ada-001',
        label: 'text-ada-001: 能够执行非常简单的任务，通常是GPT-3系列中速度最快的机型，并且成本最低'
      }, {
        value: 'code-davinci-002',
        label: 'code-davinci-002: 最强大的Codex模型。特别擅长将自然语言翻译成代码。除了完成代码外，还支持在代码中插入完成'
      }, {
        value: 'code-cushman-001',
        label: 'code-cushman-001: 几乎与Davinci Codex一样强大，但速度稍快。这种速度优势可使其更适合于实时应用'
      }],

      model: 'text-davinci-003',
      template: 0
    }
  },
  methods: {
    //发送信息给服务端
    send: function () {
      //自己输入的信息
      this.myMessage = "我: " + this.msg + "\n"
      this.message_array.push(this.myMessage)

      //加载中
      this.fullscreenLoading = true;

      //请求openai的api
      chatGPT(this.model,this.msg,this.template/100).then(response => {
        console.log("這個是chatgpt:"+JSON.stringify(response))
        console.log("this.model:"+this.model)
        console.log("this.template:"+this.template)
        if (response.status === 200) {
          //自己输入的信息
          this.myMessage = "chatGPT: " + response.data.choices[0].text + "\n"
          this.message_array.push(this.myMessage)
          this.message_array.push("------")
          //清空输入框数据
          this.msg = ""
          this.fullscreenLoading = false;
        }
      }).catch(error=>{ // 请求失败以后的回调函数
        console.log(error.response.data.error.message); // 获取错误信息
        this.$message.error('chatGPT异常，请稍后重试');
        this.message_array.push("chatGPT: " + error.response.data.error.message + "\n")
        this.message_array.push("------")
        this.fullscreenLoading = false;
      })
    },
    //template参数的配置0-1
    formatTooltip(val) {
      return val / 100;
    }
  },
}
</script>

<style scoped>

</style>